import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  useReducer,
} from "react";
import { EditFormActions } from "./actions";
import { EditFormState, initialEditFormState, reducer } from "./reducer";

export const EditFormContext = createContext<{
  state: EditFormState;
  dispatch: Dispatch<EditFormActions>;
}>({
  state: initialEditFormState,
  dispatch: () => null,
});

export const EditFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialEditFormState);

  return (
    <EditFormContext.Provider value={{ state, dispatch }}>
      {children}
    </EditFormContext.Provider>
  );
};
